<template>
  <div class="social-media-container">
    <span class="text">{{$t('SHARE_TO_ANOTHER_TEACHER')}}</span>
    <div class="share-network-btn" v-for="network in networks" :key="network.media">
        <ShareNetwork
        :network="network.media"
        :url="getUrl"
        :title="selectedEntry.data.title"
        :description="getDescription"
        >
        <div class="tooltip-btn" :data-text="$t(network.text)">
          <img :src="network.icon" :alt="network.alt"/>
          </div>
    </ShareNetwork>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/config.js'
import { htmlParser } from '@/utilityFunctions'

export default {
  name: 'social-media-entry',
  data () {
    return {
      networks: [
        {
          id: 0,
          media: 'Facebook',
          icon: require('@/assets/images/facebook_icon.svg'),
          text: 'FACEBOOK',
          alt: 'Share by Facebook'
        },
        {
          id: 1,
          media: 'Email',
          icon: require('@/assets/images/mail_icon.svg'),
          text: 'EMAIL',
          alt: 'Share by Email'
        },
        {
          id: 2,
          media: 'Twitter',
          icon: require('@/assets/images/twitter_icon.svg'),
          text: 'TWITTER',
          alt: 'Share by Twitter'
        },
        {
          id: 3,
          media: 'Whatsapp',
          icon: require('@/assets/images/whatsapp_icon.svg'),
          text: 'WHATSAPP',
          alt: 'Share by Whatsapp'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      selectedEntry: (state) => state.collections.selectedEntry,
      librarySlug: state => state.base.library?.slug
    }),
    getDescription () {
      const maxLength = 250
      const description = htmlParser(this.selectedEntry.data.description)
      return (description.length > maxLength) ? description.substr(0, maxLength) + description.match(/.{1,15}(\s|$)/g)[0] + '...' : description
    },
    getUrl () {
      return config.libraryUrl + this.librarySlug + '/collection-entry/' + this.selectedEntry.data.id
    }
  }

}
</script>

<style lang="scss" scoped>
.social-media-container{
  display: flex;  justify-content: end; align-items: center; gap: 10px;
  margin: 0.35rem 0;
  .tooltip-btn{
    &:before{
      width:80px; padding: 5px; text-align: center;
    }
    &:after{
      top: 43%;
    }
  }
}
.social-media-container .text {
  font-size: 0.75rem;
  color: #7C7979;
}
</style>
